import { ApiEnumName } from "@/common/services/enum";
import { VehicleDamageDto, VehicleDamageState } from "@/core/api/generated/v1";

import InlineApiEnumValue, { InlineApiEnumValueProps } from "../../Enum/InlineApiEnumValue";
import { StatusDisplay, StatusDisplayProps } from "../../Status/StatusDisplay";

interface Props {
  vehicleDamage: Nil<VehicleDamageDto>;
  statusProps?: Partial<StatusDisplayProps>;
  inlineApiEnumValueProps?: Partial<InlineApiEnumValueProps<"VehicleDamageState">>;
  sx?: StatusDisplayProps["sx"];
}

export const VehicleDamageStatus = ({
  vehicleDamage,
  statusProps,
  inlineApiEnumValueProps,
  sx,
}: Props) => {
  return (
    <StatusDisplay
      title={
        <InlineApiEnumValue
          type={ApiEnumName.VehicleDamageState}
          value={vehicleDamage?.state}
          withHelperTooltip
          {...inlineApiEnumValueProps}
        />
      }
      indicatorProps={{
        size: 8,
        color:
          vehicleDamage?.state === VehicleDamageState.Repaired
            ? (th) => th.palette.success.main
            : vehicleDamage?.state === VehicleDamageState.Inactive
              ? (th) => "gray"
              : (th) => th.palette.error.main,
      }}
      {...statusProps}
      sx={sx}
    />
  );
};
